/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import axios from 'axios';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
export const useNetDocsStore = defineStore('netDocsStore', {
  state: () => ({
    connected: false,
    isDisconnectedUnintentionally: false,
    loading: false,
    lastChecked: null
  }),
  getters: {
    isConnected: state => state.connected,
    isLoading: state => state.loading,
    shouldShowWarning: state => state.connected && state.isDisconnectedUnintentionally,
    status: state => ({
      connected: state.connected,
      isDisconnectedUnintentionally: state.isDisconnectedUnintentionally,
      loading: state.loading,
      lastChecked: state.lastChecked
    })
  },
  actions: {
    getErrorHandler() {
      try {
        const {
          handleError
        } = useSnackbarHandler();
        return handleError;
      } catch (error) {
        // Fallback if not in Vue context
        return err => console.error('NetDocs Store Error:', err);
      }
    },
    async checkStatus(useErrorHandler = false) {
      this.loading = true;
      try {
        const response = await axios.get('/documents/status');
        const {
          connected,
          isDisconnectedUnintentionally
        } = response.data || {};
        this.$patch({
          connected: connected || false,
          isDisconnectedUnintentionally: isDisconnectedUnintentionally || false,
          lastChecked: new Date()
        });
        return {
          connected: this.connected,
          isDisconnectedUnintentionally: this.isDisconnectedUnintentionally
        };
      } catch (error) {
        console.error('Failed to check NetDocs status:', error);
        this.$patch({
          connected: false,
          isDisconnectedUnintentionally: false,
          lastChecked: new Date()
        });
        if (useErrorHandler) {
          const handleError = this.getErrorHandler();
          handleError(error);
          return {
            connected: false,
            isDisconnectedUnintentionally: false
          };
        }
        throw error;
      } finally {
        this.loading = false;
      }
    },
    async connect(useErrorHandler = false) {
      try {
        const response = await axios.post('/documents/connect');
        await this.checkStatus(useErrorHandler);
        return response.data;
      } catch (error) {
        console.error('Failed to connect to NetDocs:', error);
        if (useErrorHandler) {
          const handleError = this.getErrorHandler();
          handleError(error);
          return null;
        }
        throw error;
      }
    },
    async disconnect(useErrorHandler = false) {
      try {
        const response = await axios.post('/documents/disconnect');
        this.$patch({
          connected: false,
          isDisconnectedUnintentionally: false
        });
        return response.data;
      } catch (error) {
        console.error('Failed to disconnect from NetDocs:', error);
        if (useErrorHandler) {
          const handleError = this.getErrorHandler();
          handleError(error);
          return null;
        }
        throw error;
      }
    },
    reset() {
      this.$patch({
        connected: false,
        isDisconnectedUnintentionally: false,
        loading: false,
        lastChecked: null
      });
    }
  }
});